import http from "../http";

/* لیست محصولات */
export const getProducts = (storeId) => {
  return http.get(`/store-management/products/?store_id=${storeId}`);
};

/* گرفتن یک محصول */
// export const getSingleProduct = (storeId, productId) => {
//   return http.get(
//     `/store-management/products/${productId}/?store_id=${storeId}`,
//   );
// };

export const getSingleProduct = (storeId, productId) => {
  return http.get(
    `/store-management/public/products/${productId}/?store_id=${storeId}`,
  );
};
/* ساخت محصول */
export const createProduct = (data) => {
  return http.post("/store-management/products/", data);
};

/* ویرایش محصول */
export const updateProduct = (storeId, productId, data) => {
  return http.put(
    `/store-management/products/${productId}/?store_id=${storeId}`,
    data,
  );
};

/* حذف محصول */
export const deleteProduct = (storeId, productId) => {
  return http.delete(
    `/store-management/products/${productId}/?store_id=${storeId}`,
  );
};

/* آپلود تصاویر */
export const uploadProductImages = (productId, files) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("image", file.file);
    formData.append("is_cover", file.is_cover);
    formData.append("is_pro_majazi", file.is_pro_majazi);
    formData.append("product", productId);
  });

  return http.post("/store-management/product-images/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteProductImage = (imageId) =>
  http.delete(`/store-management/product-images/${imageId}/`);

export const updateImageCover = (imageId, data) =>
  http.patch(`/store-management/product-images/${imageId}/`, data);
/* ویژگی محصول */
export const addAttribute = (data) => {
  return http.post("/store-management/product-attributes/", data);
};

/* رنگ محصول */
export const addColor = (data) => {
  return http.post("/store-management/product-colors/", data);
};

/* دسته‌بندی‌ها */
export const getCategories = (storeId) => {
  return http.get(`/store-management/categories/?store_id=${storeId}`);
};

/* کالکشن‌ها */
export const getCollections = (storeId) => {
  return http.get(`/store-management/collections/?store_id=${storeId}`);
};

/* حذف ویژگی */
export const deleteAttribute = (id) => {
  return http.delete(`/store-management/product-attributes/${id}/`);
};

/* حذف رنگ */
export const deleteColor = (id) => {
  return http.delete(`/store-management/product-colors/${id}/`);
};

export const getStoreCategories = (storeId) => {
  return http.get(`/store-management/categories/?store_id=${storeId}`);
};

export const getStoreCollections = (storeId) => {
  return http.get(`/store-management/collections/?store_id=${storeId}`);
};

export const getSectionProducts = (params) => {
  return http.get("/store-management/products/section_products/", {
    params,
  });
};

export const getPublicStoreCategories = (storeId) => {
  return http.get(`/store-management/public/store-categories/${storeId}/`);
};

export const getCategoryProducts = (storeId, categorySlug, params) => {
  // params شامل sort, min_price, max_price, in_stock است
  return http.get(
    `/store-management/products/category/${categorySlug}/?store_id=${storeId}`,
    {
      params,
    },
  );
};
